import type { Capability } from '@taler/api-client'

/** Owner-only: the one place this feature's view gate is written; the account menu and the route both call it. */
export function canManageLedgerLifecycle(can: (capability: Capability) => boolean): boolean {
  return can('LEDGER_LIFECYCLE_MANAGE')
}
